var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.format')
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "allow-create": ""
    },
    model: {
      value: (_vm.optionModel.format),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "format", $$v)
      },
      expression: "optionModel.format"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "HH:mm:ss",
      "value": "HH:mm:ss"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "HH时mm分ss秒",
      "value": "HH时mm分ss秒"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "hh:mm:ss",
      "value": "hh:mm:ss"
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52c22288","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/field-time/time-format-editor.vue
// module id = null
// module chunks = 